import { TextTag } from "@/ui/core";

// "Core" tag shown on core group cards/events (v2). Shared by GroupClassCard,
// GroupRegistrationCard, and ScheduleEventCard so the label/variant stay consistent.
// Callers provide their own layout wrapper (Box/HStack) as needed.
const CoreTag = ({ testID }: ViewWithTestID) => (
  <TextTag testID={testID} text="Core" variant="informational" />
);

export default CoreTag;
